import 'css-chunksrc/client/pages/costProfilesPage/resource/assignCostProfileToResource/costProfiles/costProfile/styles.scss';export default {
  "costProfile": "_costProfile_rcap2_1",
  "contextualMenu": "_contextualMenu_rcap2_6",
  "row": "_row_rcap2_13",
  "icon": "_icon_rcap2_21",
  "col": "_col_rcap2_29",
  "name": "_name_rcap2_34",
  "cost": "_cost_rcap2_1",
  "removeIcon": "_removeIcon_rcap2_52"
};